import React from 'react';
import withDrilldown from './withDrilldown';
import AgreementDrilldown from './AgreementDrilldown.js';

const InputWithDrillDown = withDrilldown(AgreementDrilldown, { field: 'hasAgreement', text: 'default.agreement' });

const Agreement = props => <InputWithDrillDown {...props} />;

export default Agreement;
